










































































import { mapGetters } from 'vuex';

const CopyAddress = (): Promise<any> =>
  import('@/components/CopyAddress.vue');
const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');
const CopyStakeWebAiStreamerProfileEditDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAiStreamer/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfileEditDialog.vue'
  );
const CopyStakeStreamerThumbnailsDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeStreamer/CopyStakeStreamerThumbnailsDialog.vue'
  );

import {
  deleteWebAiStreamer,
  getStreamersList
} from '@/api/CopyStake/Streamers';
import { TStreamer, EStreamerType, EStreamingType } from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { addThumbnailPrefix } from '@/helpers/copyStakeHelpers';

const DEFAULT_PAGINATION_OPTIONS = {
  page: 1,
  itemsPerPage: 10
};
const STREAMER_TYPE_MAP = {
  [EStreamerType.PRIVATE]: {
    label: 'Private',
    type: 'system-success'
  },
  [EStreamerType.PUBLIC]: {
    label: 'Public',
    type: 'additional-finished'
  }
};

export default {
  name: 'CopyStakeWebAiStreamerProfilesTab',
  components: {
    CopyStakeWebAiStreamerProfileEditDialog,
    CopyStakeStreamerThumbnailsDialog,
    ConfirmationDialog,
    CopyAddress,
    VStatus
  },
  data(): any {
    return {
      STREAMER_TYPE_MAP,
      isLoading: false,
      webAiStreamerProfilesList: [],
      total: null,
      tableOptions: { ...DEFAULT_PAGINATION_OPTIONS },
      dialogs: {
        webAiStreamerProfileCreateEdit: false,
        streamerThumbnails: false,
        confirm: false,
        broadcastSettings: false,
        loading: false,
        data: undefined
      }
    };
  },
  computed: {
    ...mapGetters('Onboarding', [
      'operatorId',
      'isUndergroundCasinoGamesIntegrationType'
    ]),
    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },
    headers(): any[] {
      const output = [
        { text: 'Date Added', value: 'createdAt' },
        { text: 'Nickname', value: 'nickname' },
        {
          text: 'Login',
          value: 'webAiStreamerLogin',
          hide: this.isUndergroundCasinoGamesIntegrationType
        },
        { text: 'Operator User ID', value: 'operatorUserId' },
        { text: 'Type', value: 'type' },
        { text: 'Thumbnails', value: 'images' },
        {
          text: 'Action',
          value: 'actions',
          width: 115,
          align: 'center',
          hide: !this.canEdit
        }
      ];

      return output.filter((item) => !item.hide);
    }
  },
  watch: {
    operatorId: {
      handler: 'fetchWebAiStreamerProfilesData',
      immediate: true
    }
  },
  methods: {
    addThumbnailPrefix,
    showDeleteDialog(webAiStreamerProfile: TStreamer): void {
      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer: `
          <p>
            Are you sure you want to delete <strong>${webAiStreamerProfile.nickname}</strong> Streamer Profile?
          </p>
          <p class="text--disabled">You will not be able to recover it.</p>`,
        icon: 'mdi-alert-octagon',
        header: 'Delete Streamer Profile',
        okText: 'Delete',
        handler: () =>
          this.handlerOnDeleteWebAiStreamerProfile(webAiStreamerProfile)
      };
    },
    showStreamerThumbnailsDialog(webAiStreamerProfile: TStreamer): void {
      this.dialogs.streamerThumbnails = true;
      this.dialogs.data = webAiStreamerProfile;
    },
    async handlerOnDeleteWebAiStreamerProfile(
      webAiStreamerProfile: TStreamer
    ): Promise<void> {
      try {
        this.dialogs.loading = true;

        await deleteWebAiStreamer(webAiStreamerProfile.id);
        this.fetchWebAiStreamerProfilesData();
        this.$toast.success(
          `Streamer "${webAiStreamerProfile.nickname}" profile was successfully deleted`
        );
        this.closeDialog('confirm');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.dialogs.loading = false;
      }
    },
    handlerOnCreateEditWebAiStreamerProfile(
      webAiStreamerProfile?: TStreamer
    ): void {
      if (webAiStreamerProfile) {
        this.dialogs.data = webAiStreamerProfile;
      }

      this.dialogs.webAiStreamerProfileCreateEdit = true;
    },
    closeDialog(type: string, resetData: boolean = true): void {
      this.dialogs[type] = false;

      if (resetData) {
        this.$nextTick(() => {
          this.dialogs.data = {};
        });
      }
    },
    async fetchWebAiStreamerProfilesData(): Promise<void> {
      if (!this.operatorId) return;

      try {
        this.isLoading = true;

        const { content, totalElements } = await getStreamersList({
          size: this.tableOptions.itemsPerPage,
          page: this.tableOptions.page - 1,
          operatorId: this.operatorId,
          streamingType: EStreamingType.WEB_AI
        });

        this.webAiStreamerProfilesList = content;
        this.total = totalElements || 0;
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleSubmitCreateEditWebAiStreamerProfileDialog(): Promise<void> {
      await this.fetchWebAiStreamerProfilesData();
    },
    async handleSubmitWebAiStreamerProfileThumbnailsDialog(): Promise<void> {
      await this.fetchWebAiStreamerProfilesData();
    }
  }
};
